import { FunctionComponent } from "react";
import { createPortal } from "react-dom";
import { StyledFade, StyledFrame, StyledModal } from "./modal.styles";
import Title from "components/title";

interface ModalProps {
  title?: string;
  children: any;
  wide?: boolean;
}

// RULES: sub-modal components handles all the operations related to the object edited and just signals parent about closure etc.
// sub-modals can receive onClose etc, but the main modal doesn't have those.
const Modal: FunctionComponent<ModalProps> = ({
  children,
  title,
  wide = false,
}) => {
  return createPortal(
    <StyledModal role="dialog" aria-label={title}>
      <StyledFade />
      <StyledFrame $wide={wide}>
        {title && <Title level="h2">{title}</Title>}
        {children}
      </StyledFrame>
    </StyledModal>,
    document.body,
  );
};

export default Modal;
